import $ from 'jquery';

// async function isEven(n) {
// 	if (n.length % 2 === 0) {
// 		return
// 	}
// 	return n[n.length - 1].classList.add('news__item--last');
// }

const renderContent = async (template) => {
	if (!template) return;

	const jsNews = $('.js-news');
	const news = await $.getJSON('/ajax/news.json');
	const $target = jsNews.find('.news__content > .grid');
	$target.html('');
	news.forEach((item) => {
		$target.append(template);
		const $elem = jsNews.find('.news__item').last();

		$elem.find('.news__item-category').text(item.category);
		$elem.find('.news__item-title').text(item.title);
		$elem.find('.news__item-text').text(item.text);
		$elem.find('.news__item-cta').attr('href', item.link);
		$elem.find('.news__item-cta-text').text(item.linkText);
	});
	// await isEven($('.news__item'));
};

export const init = async () => {
	const jsNews = $('.js-news');

	const hash = window.location.hash.substr(1);
	const text = jsNews.find('#news-select').parent().find(`[data-value='${hash}']`).text();
	if (hash) jsNews.find('#news-select').parent().find('.js-btn-text').text(text);

	const template = await $.get('/ajax/news.html');
	jsNews.find('.js-dropdown .js-dropdown-item').on('click', async (e) => {
		const value = $(e.target).parent().data('value');
		await renderContent(template);
		window.location.hash = value;
	});

	jsNews.find('.news__show-more').on('click', (e) => {
		e.preventDefault();
		jsNews.find('.news__content').addClass('news__content-all');
	});

	await renderContent(template);
};
